var _path, _path2, _g, _path3, _path4, _path5, _ellipse, _path6, _ellipse2, _path7, _rect, _ellipse3, _path8, _ellipse4, _path9, _ellipse5, _path10, _rect2, _path11, _ellipse6, _path12, _ellipse7, _path13, _rect3, _ellipse8, _path14, _ellipse9, _path15, _ellipse10, _path16, _rect4, _path17, _path18, _path19, _rect5, _path20, _path21, _path22, _path23, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _path24, _rect6, _path25, _path26, _ellipse15, _path27, _ellipse16, _path28, _rect7, _ellipse17, _path29, _ellipse18, _path30, _ellipse19, _path31, _rect8, _ellipse20, _path32, _ellipse21, _path33, _ellipse22, _path34, _ellipse23, _path35, _ellipse24, _path36, _rect9, _path37, _path38, _path39, _path40, _path41, _rect10, _rect11, _ellipse25, _ellipse26, _ellipse27, _path42, _rect12, _rect13, _rect14, _path43, _path44, _rect15, _path45, _path46, _path47, _path48, _path49, _path50, _ellipse28, _ellipse29, _ellipse30, _path51, _path52, _path53, _ellipse31, _ellipse32, _path54, _ellipse33, _ellipse34, _path55, _path56, _path57, _path58, _path59, _path60, _ellipse35, _path61, _path62, _path63, _ellipse36, _path64, _path65, _path66, _path67, _path68, _path69, _rect16, _rect17, _path70, _path71, _rect18, _path72;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFte4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.256 143.339H170.657V115.412H106.644L104.256 143.339V143.339Z",
    fill: "#4A90E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.841 143.72H171.034V115.034H106.295L103.841 143.72ZM170.276 142.961H104.668L106.991 115.793H170.276V142.961Z",
    fill: "#4A90E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.9244 427.284C83.9244 427.284 -7.19293 318.899 20.1018 291.16C47.3966 263.42 93.2689 293.699 85.411 262.785C77.5532 231.871 46.2432 201.883 58.8963 178.423C74.085 150.265 118.53 173.112 140.053 182.972C180.066 201.304 224.406 203.337 209.04 177.7C193.674 152.062 153.445 127.013 168.036 112.401C187.894 92.5179 297.089 166.122 343.821 223.76C371.79 258.256 392.175 234.253 389.343 212.091C387.543 198.005 367.732 168.939 388.514 155.784C408.547 143.103 455.335 182.4 471.228 206.664C512.845 270.198 444.708 426.667 444.708 426.667L83.9244 427.284Z",
    fill: "#C5CEDA"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.537 131.865V126.043C108.516 120.417 112.654 115.641 118.226 114.859C123.798 114.077 129.092 117.53 130.621 122.944L217.56 114.762H212.457V51.3784H96.8955V137.52C96.8955 140.735 99.5022 143.341 102.718 143.341C105.933 143.341 108.54 140.735 108.54 137.52V131.865H108.537Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5166 137.519C96.5199 140.942 99.2939 143.716 102.717 143.72C106.138 143.713 108.909 140.94 108.913 137.52V126.048C108.899 120.617 112.896 116.008 118.276 115.253C123.655 114.498 128.767 117.829 130.249 123.054L130.336 123.356L217.593 115.143L217.558 114.387H212.832V51H96.5166V137.519ZM97.2739 137.519V51.7588H212.073V114.9L130.89 122.541C129.17 117.053 123.699 113.646 118.016 114.523C112.332 115.4 108.143 120.297 108.157 126.047V137.519C108.157 140.524 105.721 142.96 102.716 142.96C99.7102 142.96 97.2739 140.524 97.2739 137.519Z",
    fill: "#4A90E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.115 103.706C105.071 106.015 107.324 107.52 109.823 107.52C113.234 107.517 115.998 104.754 116.002 101.343C116.002 98.8447 114.497 96.5917 112.188 95.6352C109.88 94.6787 107.222 95.207 105.455 96.9737C103.687 98.7405 103.159 101.398 104.115 103.706ZM108.957 101.343C108.957 100.864 109.344 100.476 109.823 100.475V100.472C110.054 100.472 110.275 100.564 110.438 100.727C110.601 100.891 110.692 101.113 110.691 101.343C110.691 101.822 110.303 102.21 109.824 102.21C109.345 102.209 108.957 101.821 108.957 101.343Z",
    fill: "#4A90E2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.823,
    cy: 101.339,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.922 101.338C105.921 103.493 107.668 105.24 109.823 105.241C111.977 105.24 113.723 103.494 113.726 101.34C113.726 99.1858 111.98 97.4386 109.825 97.438C107.67 97.4375 105.922 99.1837 105.922 101.338ZM106.678 101.34C106.678 99.6043 108.086 98.1969 109.822 98.1969C111.558 98.1985 112.964 99.605 112.966 101.34C112.966 103.077 111.559 104.484 109.822 104.484C108.086 104.484 106.678 103.077 106.678 101.34Z",
    fill: "#055CC0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.979,
    cy: 101.339,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.078 101.338C121.078 103.493 122.824 105.24 124.979 105.241C127.133 105.239 128.879 103.494 128.882 101.34C128.882 99.1858 127.136 97.4386 124.981 97.438C122.826 97.4375 121.079 99.1837 121.078 101.338ZM121.834 101.34C121.834 99.6043 123.242 98.1969 124.978 98.1969C126.714 98.1985 128.121 99.605 128.122 101.34C128.122 103.077 126.715 104.484 124.978 104.484C123.242 104.484 121.834 103.077 121.834 101.34Z",
    fill: "#055CC0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101.914,
    y: 90.9742,
    width: 105.161,
    height: 2.35568,
    fill: "#E1E1E1"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.291,
    cy: 101.339,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.391 101.338C151.39 103.493 153.137 105.24 155.291 105.241C157.446 105.24 159.192 103.494 159.194 101.34C159.195 99.1858 157.448 97.4386 155.293 97.438C153.139 97.4375 151.391 99.1837 151.391 101.338ZM152.148 101.34C152.148 99.6043 153.555 98.1969 155.292 98.1969C157.028 98.1985 158.434 99.605 158.436 101.34C158.436 103.077 157.028 104.484 155.292 104.484C153.555 104.484 152.148 103.077 152.148 101.34Z",
    fill: "#055CC0"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.381,
    cy: 101.339,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.775 102.832C167.378 104.29 168.801 105.241 170.379 105.241C172.533 105.238 174.278 103.494 174.281 101.34C174.282 99.7624 173.331 98.3395 171.873 97.7354C170.415 97.1312 168.737 97.4647 167.621 98.5804C166.505 99.6961 166.171 101.374 166.775 102.832ZM167.475 100.137C167.961 98.9621 169.108 98.1965 170.38 98.1969C172.115 98.1997 173.521 99.6056 173.523 101.34C173.523 102.612 172.757 103.758 171.582 104.245C170.407 104.731 169.054 104.462 168.155 103.563C167.256 102.664 166.988 101.311 167.475 100.137Z",
    fill: "#055CC0"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.137,
    cy: 101.339,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.234 101.338C136.234 103.493 137.98 105.24 140.135 105.241C142.289 105.24 144.036 103.494 144.038 101.34C144.039 99.1858 142.292 97.4386 140.137 97.438C137.982 97.4375 136.235 99.1837 136.234 101.338ZM136.992 101.341C136.991 99.6051 138.398 98.1974 140.135 98.1969C141.871 98.1974 143.278 99.6044 143.279 101.34C143.279 103.076 141.872 104.484 140.136 104.484C138.4 104.484 136.992 103.077 136.992 101.341Z",
    fill: "#055CC0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 179.744,
    y: 97.8174,
    width: 27.3309,
    height: 7.04495,
    fill: "#E1E1E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.672 72.5927C165.629 74.9011 167.882 76.406 170.381 76.4056C173.791 76.4012 176.554 73.6378 176.558 70.2279C176.558 67.7291 175.053 65.4764 172.744 64.5203C170.435 63.5641 167.778 64.0929 166.011 65.8599C164.244 67.6269 163.715 70.2842 164.672 72.5927ZM169.578 69.8949C169.713 69.5705 170.03 69.3593 170.381 69.3597V69.3587C170.86 69.3598 171.248 69.7486 171.248 70.2279C171.248 70.5791 171.037 70.8958 170.712 71.0301C170.387 71.1644 170.014 71.0899 169.766 70.8414C169.517 70.5929 169.443 70.2193 169.578 69.8949Z",
    fill: "#4A90E2"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.823,
    cy: 70.2268,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.92 70.2268C105.92 72.3821 107.667 74.1292 109.823 74.1292C111.977 74.127 113.723 72.3811 113.726 70.2268C113.726 68.0716 111.978 66.3245 109.823 66.3245C107.667 66.3245 105.92 68.0716 105.92 70.2268ZM106.679 70.2269C106.679 68.4907 108.087 67.0833 109.823 67.0833C111.559 67.0849 112.965 68.4914 112.967 70.2269C112.967 71.963 111.559 73.3704 109.823 73.3704C108.087 73.3704 106.679 71.963 106.679 70.2269Z",
    fill: "#055CC0"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.979,
    cy: 70.2268,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.375 71.7202C121.979 73.1784 123.403 74.1292 124.981 74.1292C127.135 74.1264 128.881 72.3809 128.884 70.2268C128.884 68.6485 127.933 67.2255 126.475 66.6215C125.016 66.0175 123.338 66.3514 122.221 67.4674C121.105 68.5835 120.771 70.262 121.375 71.7202ZM121.837 70.2268C121.837 68.4907 123.245 67.0832 124.981 67.0832C126.717 67.0849 128.124 68.4914 128.125 70.2268C128.125 71.963 126.718 73.3704 124.981 73.3704C123.245 73.3704 121.837 71.963 121.837 70.2268Z",
    fill: "#055CC0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 101.914,
    y: 59.8607,
    width: 105.161,
    height: 2.35568,
    fill: "#E1E1E1"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.291,
    cy: 70.2268,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.389 70.2268C151.389 72.3821 153.136 74.1292 155.292 74.1292C157.446 74.127 159.192 72.3811 159.194 70.2268C159.194 68.0716 157.447 66.3245 155.292 66.3245C153.136 66.3245 151.389 68.0716 151.389 70.2268ZM152.148 70.2269C152.148 68.4907 153.555 67.0833 155.292 67.0833C157.027 67.0849 158.434 68.4914 158.436 70.2269C158.436 71.963 157.028 73.3704 155.292 73.3704C153.555 73.3704 152.148 71.963 152.148 70.2269Z",
    fill: "#055CC0"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.381,
    cy: 70.2268,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.774 71.7209C167.378 73.1791 168.802 74.1296 170.381 74.1292C172.534 74.1259 174.28 72.3805 174.282 70.2268C174.282 68.6484 173.331 67.2254 171.873 66.6214C170.414 66.0175 168.736 66.3515 167.619 67.4678C166.503 68.5841 166.17 70.2627 166.774 71.7209ZM167.475 69.0231C167.962 67.8485 169.109 67.0828 170.381 67.0832C172.116 67.086 173.522 68.492 173.524 70.2268C173.524 71.4984 172.758 72.6447 171.583 73.1312C170.408 73.6177 169.055 73.3486 168.156 72.4493C167.257 71.5501 166.988 70.1978 167.475 69.0231Z",
    fill: "#055CC0"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.137,
    cy: 70.2268,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.232 70.2268C136.232 72.3821 137.98 74.1292 140.135 74.1292C142.29 74.127 144.036 72.3811 144.038 70.2268C144.038 68.0716 142.291 66.3245 140.135 66.3245C137.98 66.3245 136.232 68.0716 136.232 70.2268ZM136.993 70.2275C136.992 68.4915 138.399 67.0838 140.135 67.0833C141.872 67.0838 143.279 68.4908 143.28 70.2269C143.28 71.9629 141.873 73.3703 140.137 73.3705C138.401 73.3706 136.993 71.9636 136.993 70.2275Z",
    fill: "#055CC0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 179.744,
    y: 66.7048,
    width: 27.3309,
    height: 7.04495,
    fill: "#E1E1E1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M223.5 114.766H119.819C122.812 114.766 125.681 115.954 127.797 118.07C129.913 120.186 131.101 123.055 131.101 126.047V139.531H234.782V126.047C234.783 123.055 233.594 120.186 231.478 118.07C229.362 115.954 226.493 114.766 223.5 114.766Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.722 139.911H235.162V126.05C235.155 119.613 229.937 114.397 223.499 114.39H119.819V115.148C125.837 115.156 130.713 120.031 130.722 126.047V139.911ZM234.403 139.152H131.48V126.051C131.475 121.209 128.483 116.872 123.958 115.148H223.499C229.517 115.154 234.395 120.03 234.403 126.047V139.152Z",
    fill: "#4A90E2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M262.011 176.486V230.876H122.461V129.303H262.011V176.486",
    fill: "#E1E1E1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 138.507,
    y: 145.349,
    width: 123.505,
    height: 8.72213,
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M262.012 136.758V145.349H122.461V129.305H262.012V136.758",
    fill: "#4A90E2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M129.914 128.609H138.506V230.879H122.461V128.609H129.914",
    fill: "#055CC0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.944 232.395H264.475V127.092H120.944V232.395ZM261.441 229.361H123.979V130.126H261.441V229.361Z",
    fill: "#0134A0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.944 232.395H264.475V127.092H120.944V232.395ZM261.441 229.361H123.979V130.126H261.441V229.361Z",
    fill: "#0134A0"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.484,
    cy: 155.87,
    rx: 3.97009,
    ry: 3.96962,
    fill: "#E6E6E8"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.484,
    cy: 168.283,
    rx: 3.97009,
    ry: 3.96962,
    fill: "#8896AA"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.484,
    cy: 180.696,
    rx: 3.97009,
    ry: 3.96962,
    fill: "#E6E6E8"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.484,
    cy: 193.109,
    rx: 3.97009,
    ry: 3.96962,
    fill: "#E6E6E8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.729 174.561C190.728 177.972 193.493 180.738 196.905 180.739C200.315 180.736 203.08 177.973 203.083 174.563C203.084 171.152 200.319 168.386 196.907 168.385C193.495 168.385 190.729 171.15 190.729 174.561ZM196.039 174.562C196.039 174.084 196.426 173.696 196.905 173.695C197.385 173.695 197.774 174.084 197.774 174.563C197.773 175.042 197.385 175.43 196.906 175.429C196.427 175.429 196.039 175.041 196.039 174.562Z",
    fill: "#4A90E2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 143.526,
    y: 197.254,
    width: 105.161,
    height: 2.35568,
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.222 184.645H202.506H202.51V200.556H170.505L168.196 202.864L165.607 205.454V200.557H162.222V184.645ZM200.991 199.039V186.162H200.988H163.735V199.039H167.12V201.791L169.873 199.039H200.991Z",
    fill: "#E1E1E1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.413 207.618C160.413 211.03 163.178 213.796 166.591 213.797C170.002 213.794 172.767 211.031 172.77 207.62C172.771 204.208 170.005 201.442 166.593 201.441C163.18 201.441 160.414 204.206 160.413 207.618ZM165.723 207.62C165.723 207.14 166.111 206.752 166.591 206.752C166.821 206.752 167.042 206.843 167.205 207.006C167.368 207.169 167.459 207.39 167.459 207.62C167.459 208.099 167.07 208.488 166.591 208.488C166.111 208.488 165.723 208.099 165.723 207.62Z",
    fill: "#4A90E2"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.434,
    cy: 174.562,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.533 174.561C147.533 176.716 149.279 178.463 151.434 178.464C153.588 178.462 155.334 176.717 155.337 174.563C155.337 172.408 153.591 170.661 151.436 170.661C149.281 170.66 147.534 172.406 147.533 174.561ZM148.292 174.562C148.292 172.827 149.699 171.42 151.434 171.42C153.17 171.421 154.577 172.828 154.578 174.563C154.578 176.298 153.171 177.705 151.435 177.705C149.699 177.704 148.293 176.298 148.292 174.562Z",
    fill: "#055CC0"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.592,
    cy: 174.562,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.69 174.561C162.69 176.716 164.436 178.463 166.591 178.464C168.745 178.462 170.492 176.717 170.494 174.563C170.495 172.408 168.748 170.661 166.593 170.661C164.438 170.66 162.691 172.406 162.69 174.561ZM163.451 174.563C163.45 172.828 164.856 171.421 166.591 171.42C168.328 171.42 169.735 172.827 169.736 174.563C169.736 176.298 168.329 177.705 166.593 177.705C164.858 177.705 163.451 176.298 163.451 174.563Z",
    fill: "#055CC0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 143.526,
    y: 164.196,
    width: 105.161,
    height: 2.35568,
    fill: "white"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.903,
    cy: 174.562,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.297 176.055C193.901 177.514 195.325 178.464 196.904 178.464C199.055 178.46 200.799 176.718 200.804 174.567C200.806 172.989 199.856 171.564 198.398 170.959C196.94 170.354 195.261 170.687 194.144 171.802C193.027 172.918 192.693 174.597 193.297 176.055ZM193.762 174.562C193.762 172.827 195.168 171.42 196.904 171.42C198.64 171.421 200.046 172.828 200.048 174.563C200.047 176.298 198.64 177.705 196.905 177.705C195.169 177.705 193.762 176.298 193.762 174.562Z",
    fill: "#055CC0"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.992,
    cy: 174.562,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.09 174.561C208.089 176.716 209.836 178.463 211.991 178.464C214.145 178.462 215.891 176.717 215.894 174.563C215.894 172.408 214.148 170.661 211.993 170.661C209.838 170.66 208.09 172.406 208.09 174.561ZM208.85 174.563C208.849 172.828 210.255 171.421 211.991 171.42C213.727 171.42 215.135 172.827 215.136 174.563C215.135 176.298 213.728 177.705 211.993 177.705C210.257 177.705 208.851 176.298 208.85 174.563Z",
    fill: "#055CC0"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.747,
    cy: 174.562,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.139 176.056C178.744 177.514 180.168 178.465 181.747 178.464C183.898 178.46 185.641 176.718 185.646 174.567C185.648 172.988 184.698 171.564 183.24 170.959C181.781 170.354 180.102 170.687 178.985 171.803C177.869 172.919 177.535 174.598 178.139 176.056ZM178.605 174.562C178.605 172.827 180.011 171.42 181.747 171.42C183.482 171.421 184.889 172.828 184.891 174.563C184.89 176.298 183.483 177.705 181.747 177.705C180.012 177.705 178.605 176.298 178.605 174.562Z",
    fill: "#055CC0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 221.355,
    y: 171.04,
    width: 27.3309,
    height: 7.04495,
    fill: "white"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 151.434,
    cy: 207.62,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.829 209.112C148.433 210.571 149.857 211.521 151.435 211.521C153.589 211.519 155.335 209.774 155.338 207.62C155.338 206.042 154.388 204.618 152.929 204.014C151.471 203.41 149.792 203.743 148.676 204.859C147.559 205.975 147.225 207.654 147.829 209.112ZM148.291 207.62C148.291 205.884 149.699 204.476 151.435 204.476V204.477C153.171 204.479 154.577 205.885 154.579 207.62C154.579 209.356 153.172 210.764 151.435 210.764C149.699 210.764 148.291 209.356 148.291 207.62Z",
    fill: "#055CC0"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.592,
    cy: 207.62,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.985 209.112C163.589 210.571 165.012 211.521 166.59 211.521C168.745 211.52 170.491 209.774 170.493 207.62C170.494 206.042 169.543 204.618 168.085 204.014C166.626 203.41 164.947 203.743 163.831 204.859C162.715 205.975 162.381 207.654 162.985 209.112ZM163.448 207.621C163.447 205.885 164.854 204.477 166.591 204.476V204.477C168.326 204.478 169.734 205.884 169.736 207.62C169.736 209.356 168.328 210.763 166.592 210.764C164.856 210.764 163.448 209.357 163.448 207.621Z",
    fill: "#055CC0"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.903,
    cy: 207.62,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.298 209.112C193.902 210.571 195.325 211.521 196.904 211.521C199.058 211.519 200.804 209.774 200.807 207.62C200.807 206.042 199.857 204.618 198.398 204.014C196.94 203.41 195.261 203.743 194.145 204.859C193.028 205.975 192.694 207.654 193.298 209.112ZM193.76 207.62C193.76 205.884 195.168 204.476 196.904 204.476V204.477C198.639 204.479 200.046 205.885 200.048 207.62C200.048 209.356 198.64 210.764 196.904 210.764C195.168 210.764 193.76 209.356 193.76 207.62Z",
    fill: "#055CC0"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.992,
    cy: 207.62,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.385 209.112C208.989 210.571 210.412 211.521 211.991 211.521C214.145 211.52 215.891 209.774 215.894 207.62C215.894 206.042 214.943 204.618 213.485 204.014C212.027 203.41 210.348 203.743 209.231 204.859C208.115 205.975 207.781 207.654 208.385 209.112ZM208.848 207.621C208.848 205.885 210.255 204.477 211.991 204.476V204.477C213.727 204.478 215.134 205.884 215.136 207.62C215.136 209.356 213.729 210.763 211.992 210.764C210.256 210.764 208.848 209.357 208.848 207.621Z",
    fill: "#055CC0"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.747,
    cy: 207.62,
    rx: 3.52239,
    ry: 3.52197,
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.142 209.112C178.746 210.571 180.169 211.521 181.748 211.521C183.902 211.52 185.648 209.774 185.651 207.62C185.651 206.042 184.7 204.618 183.242 204.014C181.784 203.41 180.105 203.743 178.988 204.859C177.872 205.975 177.538 207.654 178.142 209.112ZM178.604 207.62C178.604 205.884 180.012 204.476 181.748 204.476V204.477C183.483 204.479 184.89 205.885 184.892 207.62C184.892 209.356 183.484 210.764 181.748 210.764C180.012 210.764 178.604 209.356 178.604 207.62Z",
    fill: "#055CC0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 221.355,
    y: 204.097,
    width: 27.3309,
    height: 7.04495,
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M179.671 213.931C179.678 214.032 179.627 214.128 179.54 214.179C179.5 214.225 179.447 214.26 179.389 214.28L173.976 215.695L171.954 220.922C171.887 221.077 171.733 221.176 171.564 221.173C171.399 221.163 171.259 221.049 171.216 220.89L167.702 209.188C167.67 209.049 167.717 208.904 167.824 208.811C167.932 208.718 168.082 208.692 168.214 208.743L179.457 213.561C179.605 213.62 179.694 213.773 179.671 213.931Z",
    fill: "#0134A0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M200.991 185.07H163.738V199.039H167.123V201.791L169.876 199.039H200.991V185.07V185.07Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.745 199.419V202.707L170.033 199.419H201.373V184.69H163.361V199.419H166.745ZM167.504 198.66H164.119V185.449H200.612V198.66H169.719L167.504 200.876V198.66Z",
    fill: "#055CC0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M223.438 426.757H255.326V416.968H234.107L221.928 422.142C220.995 422.464 220.347 423.315 220.285 424.3V424.3C220.285 425.657 221.697 426.757 223.438 426.757Z",
    fill: "#192335"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M266.059 426.757H297.948V416.968H276.727L264.547 422.142C263.613 422.464 262.965 423.315 262.902 424.3V424.3C262.905 425.657 264.318 426.757 266.059 426.757Z",
    fill: "#192335"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 116.41,
    y: 230.878,
    width: 197.547,
    height: 8.4953,
    fill: "#0134A0"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 116.41,
    y: 230.878,
    width: 197.547,
    height: 8.4953,
    fill: "#0134A0"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.694,
    cy: 292.322,
    rx: 11.323,
    ry: 11.3217,
    fill: "#AB9AF7"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.027,
    cy: 290.081,
    rx: 13.3638,
    ry: 13.3622,
    fill: "#AB9AF7"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.379,
    cy: 290.085,
    rx: 13.3638,
    ry: 13.3622,
    fill: "#AB9AF7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M329.404 276.722L328.749 290.085L328.716 290.74C328.367 297.858 322.493 303.449 315.366 303.447H272.049C264.922 303.449 259.048 297.858 258.698 290.74L258.666 290.085L258.011 276.722L329.404 276.722Z",
    fill: "#AB9AF7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8848,
    y: 237.18,
    width: 371.405,
    height: 10.6121,
    fill: "#0134A0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 103.852,
    y: 438.237,
    width: 184.441,
    height: 1.45837,
    fill: "#293F51"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 312.753,
    y: 438.237,
    width: 94.2763,
    height: 1.45837,
    fill: "#293F51"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M109.922 246.822L108.933 256.253L90.1732 427.325H85.4111L99.4916 246.822H109.922V246.822Z",
    fill: "#0134A0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M409.631 246.822L410.622 256.253L429.38 427.325H434.142L420.063 246.822H409.631V246.822Z",
    fill: "#0134A0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 16.627,
    y: 426.564,
    width: 472.195,
    height: 1.45837,
    fill: "#293F51"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.614 194.431H256.013V191.039H240.614V194.431ZM255.711 194.13H240.917L240.916 191.342H255.711V194.13Z",
    fill: "#055CC0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M277.86 317.104L220.347 317.346L219.452 281.065L276.805 275.884L277.86 317.104V317.104Z",
    fill: "#658FDF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M226.652 212.957L302.277 227.76L301.154 239.401L297.184 239.402L291.318 239.401L224.104 239.42L226.652 212.957V212.957Z",
    fill: "#C9DEF6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M301.16 239.397L302.282 227.756L297.189 226.759V239.398L301.16 239.397V239.397Z",
    fill: "#C9DEF6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M279.842 154.607H315.52V115.537C315.519 103.653 305.884 94.019 293.999 94.0185V94.0185C282.517 94.0185 272.081 103.031 271.525 114.494L270.081 144.359C269.951 147.03 270.921 149.638 272.765 151.574C274.61 153.511 277.168 154.607 279.842 154.607Z",
    fill: "#E6BBA6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M306.513 185.468H297.639C292.665 185.468 288.633 181.437 288.633 176.464V144.674H315.515V176.465C315.515 181.436 311.485 185.467 306.513 185.468V185.468Z",
    fill: "#E6BBA6"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 302.077,
    cy: 172.028,
    rx: 13.4421,
    ry: 13.4405,
    fill: "#E6BBA6"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.588,
    cy: 292.322,
    rx: 11.323,
    ry: 11.3217,
    fill: "#4A90E2"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.588,
    cy: 292.322,
    rx: 11.323,
    ry: 11.3217,
    fill: "#658FDF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M257.483 417.615L239.55 291.675L209.31 293.448L228.46 417.615H257.483V417.615Z",
    fill: "#658FDF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M299.781 417.615L281.848 291.675L251.608 293.448L270.759 417.615H299.781V417.615Z",
    fill: "#658FDF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M335.477 276.723C335.483 281.302 334.602 285.84 332.883 290.085H266.681C261.292 276.735 264.451 261.455 274.693 251.336C284.935 241.218 300.254 238.243 313.54 243.791C326.825 249.34 335.476 262.326 335.477 276.723Z",
    fill: "#AB9AF7"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 299.779,
    cy: 276.723,
    rx: 9.79021,
    ry: 9.78906,
    fill: "#40327A"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 375.504,
    cy: 225.999,
    rx: 13.3547,
    ry: 13.3532,
    transform: "rotate(-4.699 375.504 225.999)",
    fill: "#C9DEF6"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M315.131 200.461L367.903 236.982L385.085 216.697L340.323 170.718L315.131 200.461V200.461Z",
    fill: "#C9DEF6"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 326.223,
    cy: 184.481,
    rx: 19.5787,
    ry: 19.5769,
    transform: "rotate(-18.7249 326.223 184.481)",
    fill: "#C9DEF6"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.221,
    cy: 238.074,
    rx: 7.83112,
    ry: 7.83149,
    transform: "rotate(-56.899 314.221 238.074)",
    fill: "#FF95A9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M306.922 234.65C306.465 236.981 304.649 238.808 302.32 239.279C299.991 239.749 297.608 238.771 296.282 236.8C294.956 234.828 294.948 232.253 296.262 230.273C297.576 228.294 299.953 227.301 302.285 227.757C303.814 228.056 305.162 228.95 306.031 230.243C306.901 231.536 307.221 233.121 306.922 234.65V234.65Z",
    fill: "#FF95A9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M310.617 245.03L298.453 238.738L302.284 227.757L315.725 230.388L310.617 245.03V245.03Z",
    fill: "#FF95A9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M237.199 228.622C235.78 235.856 228.766 240.571 221.531 239.154C214.296 237.737 209.579 230.725 210.995 223.49C212.411 216.256 219.423 211.539 226.659 212.953C230.135 213.632 233.199 215.665 235.176 218.604C237.152 221.543 237.88 225.147 237.199 228.622V228.622Z",
    fill: "#C9DEF6"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M284.438 200.448L231.706 237.028L214.502 216.763L259.213 170.734L284.438 200.448V200.448Z",
    fill: "#C9DEF6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M284.441 200.447L240.657 230.818L222.094 208.942L259.211 170.731L284.441 200.447V200.447Z",
    fill: "#C9DEF6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M315.131 200.461L358.947 230.784L377.487 208.888L340.328 170.718L315.131 200.461V200.461Z",
    fill: "#C9DEF6"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.276,
    cy: 184.362,
    rx: 19.5784,
    ry: 19.5802,
    transform: "rotate(-71.334 273.276 184.362)",
    fill: "#C9DEF6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M340.261 179.16L335.473 276.72H264.083L259.296 179.16C259.112 175.413 260.472 171.755 263.059 169.038C265.646 166.321 269.234 164.783 272.986 164.783H326.57C330.322 164.783 333.91 166.321 336.497 169.038C339.084 171.755 340.445 175.413 340.261 179.16Z",
    fill: "#C9DEF6"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M335.998 277.206L379.558 427.281H384.563L348.944 277.206H335.998V277.206Z",
    fill: "#0134A0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M290.449 277.206L246.89 427.281H241.884L277.502 277.206H290.449V277.206Z",
    fill: "#0134A0"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.223,
    cy: 255.799,
    rx: 73.3568,
    ry: 73.3482,
    fill: "#000B64"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M325.118 209.627H301.328C300.013 209.629 298.75 209.107 297.82 208.177C296.889 207.248 296.366 205.986 296.366 204.671V204.671C296.366 201.934 298.585 199.715 301.323 199.715H325.113C326.428 199.715 327.689 200.237 328.618 201.166C329.548 202.096 330.07 203.357 330.069 204.671V204.671C330.07 207.406 327.854 209.625 325.118 209.627V209.627Z",
    fill: "#C9DEF6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M266.783 96.8428V108.462C266.78 109.338 266.889 110.212 267.106 111.061H288.969V85.1166H278.512C275.401 85.1156 272.417 86.3506 270.218 88.5499C268.018 90.7492 266.782 93.7324 266.783 96.8428V96.8428Z",
    fill: "#8896AA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M326.271 127.131H303.795V90.3439H311.213C319.529 90.3439 326.271 97.0845 326.271 105.399V127.131Z",
    fill: "#8896AA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M268.461 108.571H291.701C300.785 108.561 308.146 101.2 308.156 92.1174C308.188 89.3035 306.705 86.6895 304.272 85.2733C301.84 83.857 298.835 83.857 296.403 85.2733C293.971 86.6895 292.487 89.3035 292.519 92.1174C292.519 92.569 292.153 92.9349 291.701 92.9355H268.461V108.571Z",
    fill: "#8896AA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M276.766 100.751H288.819C291.633 100.783 294.247 99.3002 295.664 96.8684C297.08 94.4366 297.08 91.4313 295.664 88.9995C294.247 86.5677 291.633 85.0848 288.819 85.1167H276.766C273.951 85.0848 271.337 86.5677 269.921 88.9995C268.504 91.4313 268.504 94.4366 269.921 96.8684C271.337 99.3002 273.951 100.783 276.766 100.751Z",
    fill: "#8896AA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M264.52 105.814C264.52 112.323 269.797 117.6 276.307 117.6C282.818 117.6 288.968 112.323 288.968 105.814C288.968 99.3049 282.815 94.0265 276.307 94.0265C273.181 94.0265 270.182 95.2684 267.972 97.479C265.761 99.6896 264.519 102.688 264.52 105.814Z",
    fill: "#8896AA"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 309.106,
    y: 114.643,
    width: 32.5768,
    height: 12.215,
    transform: "rotate(-180 309.106 114.643)",
    fill: "#8896AA"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 308.17,
    y: 130.062,
    width: 25.1656,
    height: 15.5804,
    transform: "rotate(-180 308.17 130.062)",
    fill: "#8896AA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M312.548 151.882H300.201C293.943 151.879 288.871 146.807 288.868 140.55V123.778H326.271V138.171C326.267 145.746 320.124 151.884 312.548 151.882V151.882Z",
    fill: "#8896AA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M288.867 124.199H283.683C278.495 124.199 274.289 119.993 274.289 114.805V110.176H288.867V124.199Z",
    fill: "#8896AA"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 283.687,
    y: 157.277,
    width: 35.1335,
    height: 11.0055,
    fill: "#C9DEF6"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M283.004 135.796H277.14V124.07H283.004C286.242 124.07 288.868 126.695 288.868 129.933V129.933C288.868 133.171 286.243 135.796 283.004 135.796V135.796Z",
    fill: "#E6BBA6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFte4);
export default __webpack_public_path__ + "static/media/FTE4.74be65695fc95913d2e678a3dd3f823e.svg";
export { ForwardRef as ReactComponent };